<button (click)="onClick($event)" type="submit" [disabled]="disabled" [class.secondary]="secondary" [class.fullWidth]="fullWidth"
    >{{title}}<img *ngIf="icon !== ''" [src]="icon" /></button>